import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const BookingConfirmation = ({ bookingData }) => {
  const navigate = useNavigate();

  const formatDate = (date) => {
    return new Date(date)?.toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="mt-8 max-w-3xl mx-auto">
      <div className="bg-card rounded-lg shadow-elevation-3 p-8 text-center">
        <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="CheckCircle2" size={48} color="var(--color-success)" strokeWidth={2} />
        </div>

        <h2 className="font-heading text-3xl font-bold text-foreground mb-2">
          Booking Confirmed!
        </h2>
        <p className="font-body text-lg text-muted-foreground mb-8">
          Your trailer rental has been successfully confirmed. We've sent a confirmation email with all the details.
        </p>

        <div className="bg-muted rounded-lg p-6 mb-8 text-left">
          <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
            <span className="font-caption text-sm text-muted-foreground uppercase">
              Booking ID
            </span>
            <span className="font-body text-base font-semibold text-foreground">
              {bookingData?.bookingId}
            </span>
          </div>

          <div className="space-y-4">
            <div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-2">
                {bookingData?.trailer?.title}
              </h3>
              <div className="flex items-center space-x-2 text-muted-foreground">
                <Icon name="MapPin" size={16} strokeWidth={2} />
                <span className="font-body text-sm">{bookingData?.trailer?.location}</span>
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border">
              <div>
                <p className="font-caption text-xs text-muted-foreground uppercase mb-1">
                  Pick-up Date
                </p>
                <p className="font-body text-base font-medium text-foreground">
                  {formatDate(bookingData?.startDate)}
                </p>
              </div>
              <div>
                <p className="font-caption text-xs text-muted-foreground uppercase mb-1">
                  Return Date
                </p>
                <p className="font-body text-base font-medium text-foreground">
                  {formatDate(bookingData?.endDate)}
                </p>
              </div>
            </div>

            <div className="pt-4 border-t border-border">
              <div className="flex items-center justify-between">
                <span className="font-body text-base text-muted-foreground">
                  Total Amount Paid
                </span>
                <span className="font-heading text-xl font-bold text-primary">
                  ${bookingData?.pricing?.total?.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-3 mb-8">
          <div className="flex items-start space-x-3 p-4 bg-primary/5 rounded-md text-left">
            <Icon name="Calendar" size={20} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <p className="font-body text-sm font-medium text-foreground mb-1">
                What's Next?
              </p>
              <p className="font-body text-sm text-muted-foreground">
                The trailer owner will contact you within 24 hours to confirm pickup details and location.
              </p>
            </div>
          </div>

          <div className="flex items-start space-x-3 p-4 bg-primary/5 rounded-md text-left">
            <Icon name="Mail" size={20} color="var(--color-primary)" strokeWidth={2} />
            <div>
              <p className="font-body text-sm font-medium text-foreground mb-1">
                Check Your Email
              </p>
              <p className="font-body text-sm text-muted-foreground">
                We've sent a confirmation email with your booking details and rental agreement.
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button
            variant="default"
            size="lg"
            iconName="Home"
            iconPosition="left"
            onClick={() => navigate('/home-page')}
          >
            Back to Home
          </Button>
          <Button
            variant="outline"
            size="lg"
            iconName="Search"
            iconPosition="left"
            onClick={() => navigate('/search-results')}
          >
            Browse More Trailers
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BookingConfirmation;